import { createAppRules } from '../ability';
import { Action, Subject } from '../data';

export const ADMINISTRATOR_RULES = createAppRules(can => {
	can(Action.all, Object.values(Subject));
});
